<div class="h-100 w-100 d-flex flex-column align-items-stretch justify-content-start">
    <div class="w-100 h-auto flex-grow-1 overflow-auto" [puDashboard]="{dashboard: 'reportsupervise'}">
    </div>
</div>